import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=d219519e&scoped=true"
import script from "./ProductEditor.vue?vue&type=script&lang=js"
export * from "./ProductEditor.vue?vue&type=script&lang=js"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&id=d219519e&prod&lang=scss"
import style1 from "./ProductEditor.vue?vue&type=style&index=1&id=d219519e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d219519e",
  null
  
)

export default component.exports